export class GlobalTranslationVar {
	public static SELECTED_LANGUAGE: string;
}
